export default __webpack_public_path__ + "static/media/flag-south-africa.683cb6e8.svg";